import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';

export default createSelector(
  [selectDomain],
  globalState => globalState.settings.commercial
);
